import { render } from "./PaymentMethodLink.vue?vue&type=template&id=a59d4982&ts=true"
import script from "./PaymentMethodLink.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodLink.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/diego/Projects/SL360/spylive360/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__